import React, { useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { useRequest } from 'ahooks'
import $msg from '@/utils/message'
import { getMemberPointsRecords } from '../../api'
import {
    formatAmount,
    formatDateTime,
    getOperatorName,
    getShopName,
    POINTS_CHANGE_TYPE_LIST,
    POINTS_CHANGE_TYPE_MAP,
    RECORD_PAGE_SIZE,
} from './record-utils'
import MemberRecordTable from './record-table'

interface Props {
    memberId: number
}

const PointsRecord: React.FC<Props> = props => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(RECORD_PAGE_SIZE)
    const req = useRequest(
        () =>
            getMemberPointsRecords({
                member_id: props.memberId,
                page,
                limit: pageSize,
                change_type: POINTS_CHANGE_TYPE_LIST,
            }),
        {
            refreshDeps: [props.memberId, page, pageSize],
            onError: e => $msg('error', e.message || '获取积分变动失败'),
        },
    )
    const columns: ColumnsType<any> = [
        { title: '时间', dataIndex: 'create_time', width: 170, render: formatDateTime },
        {
            title: '变动类型',
            dataIndex: 'change_type',
            width: 140,
            render: value => POINTS_CHANGE_TYPE_MAP[value] || '-',
        },
        { title: '店铺', dataIndex: 'shop', width: 160, render: getShopName },
        { title: '订单号', dataIndex: 'order_no', width: 220, render: value => value || '-' },
        { title: '变动积分', dataIndex: 'change_points', width: 112, render: formatAmount },
        { title: '变动后积分', dataIndex: 'remain_points', width: 120, render: formatAmount },
        { title: '操作员', dataIndex: 'creator', width: 112, render: getOperatorName },
        { title: '备注', dataIndex: 'remark', width: 180, render: value => value || '-' },
    ]

    return (
        <MemberRecordTable
            rowKey={(record, index) => record.id || index}
            loading={req.loading}
            columns={columns}
            dataSource={req.data?.points_change_record_list || []}
            page={page}
            pageSize={pageSize}
            pagination={req.data?.pagination}
            onPageChange={setPage}
            onPageSizeChange={(nextPage, nextSize) => {
                setPage(nextPage)
                setPageSize(nextSize)
            }}
        />
    )
}

export default PointsRecord
